import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom'; // Import useLocation
import './NavigationBar.css';
import { useAuth } from '../context/AuthContext';
import NotificationModal from './NotificationModal';
import todoService from '../api/todoService';
import moment from 'moment';

function NavigationBar() {
  const [isManagementDropdownOpen, setIsManagementDropdownOpen] = useState(false);
  const [isNotificationModalOpen, setIsNotificationModalOpen] = useState(false);
  const [hasTodayTodo, setHasTodayTodo] = useState(false);
  const { user, logout } = useAuth();
  const location = useLocation(); // Get location object

  // The paths to apply the active style to
  const activePaths = ['/homePage', '/schedule', '/work-orders', '/statistics', '/downloads'];

  useEffect(() => {
    const checkTodayTodos = async () => {
      if (user) {
        try {
          const response = await todoService.getTodos();
          const today = moment().format('YYYY-MM-DD');
          const hasTodo = response.data.some(todo => moment(todo.date).isSameOrBefore(today, 'day') && !todo.checked);
          setHasTodayTodo(hasTodo);
        } catch (error) {
          console.error("Failed to fetch todos for notification:", error);
        }
      }
    };

    checkTodayTodos();
    // Also check every time the modal is closed
  }, [user, isNotificationModalOpen]);

  const toggleManagementDropdown = () => {
    setIsManagementDropdownOpen(!isManagementDropdownOpen);
  };

  const toggleNotificationModal = () => {
    setIsNotificationModalOpen(!isNotificationModalOpen);
  };

  // Helper function to get class name
  const getLinkClassName = (path) => {
    if (activePaths.includes(path) && location.pathname === path) {
      return 'nav-links active';
    }
    return 'nav-links';
  };

  return (
    <nav className="navbar">
      <Link to="/" className="nav-logo">
        <img src="/LogoAndCompany.png" alt="Logo" className="navbar-logo" />
      </Link>
      <ul className="nav-menu">
        {/* ... other nav items ... */}
        <li className="nav-item">
          <Link to="/" className="nav-links">메인</Link>
        </li>
        <li className="nav-item">
          <Link to="/homePage" className={getLinkClassName('/homePage')}>대시보드</Link>
        </li>
        <li className="nav-item">
          <Link to="/schedule" className={getLinkClassName('/schedule')}>공사 배치</Link>
        </li>
        <li className="nav-item">
          <Link to="/work-orders" className={getLinkClassName('/work-orders')}>작업 지시</Link>
        </li>
        {user && ['ADMIN', 'MIDADMIN', 'USER'].includes(user.role) &&  (
          <>
            <li className="nav-item">
              <Link to="/statistics" className={getLinkClassName('/statistics')}>통계/분석</Link>
            </li>
          </>
        )}
        <li className="nav-item">
          <Link to="/downloads" className={getLinkClassName('/downloads')}>다운로드</Link>
        </li>
        <li className="nav-item dropdown" onMouseEnter={() => setIsManagementDropdownOpen(true)} onMouseLeave={() => setIsManagementDropdownOpen(false)}>
          <span className="nav-links dropdown-toggle" onClick={toggleManagementDropdown}>
            관리 {'\u00A0'}{'\u00A0'}<i className="fas fa-caret-down"></i>
          </span>
          {isManagementDropdownOpen && (
            <ul className="dropdown-menu">
              {user && ['ADMIN', 'MIDADMIN', 'USER'].includes(user.role) && (
                <li className="dropdown-item">
                  <Link to="/company-info" className="nav-links">회사정보</Link>
                </li>
              )}
              <li className="dropdown-item">
                <Link to="/tasks" className="nav-links">공사 관리</Link>
              </li>
              {user && ['ADMIN', 'MIDADMIN', 'USER'].includes(user.role) &&  (
                <>
                  <li className="dropdown-item">
                    <Link to="/association-reports" className="nav-links">협회신고관리</Link>
                  </li>
              </>
              )}
              {user && ['ADMIN', 'MIDADMIN', 'USER'].includes(user.role) &&  (
                <>
                  <li className="dropdown-item">
                    <Link to="/supervisors" className="nav-links">감리원 관리</Link>
                  </li>
              </>
              )}
              <li className="dropdown-item">
                <Link to="/contractors" className="nav-links">시공사 관리</Link>
              </li>
              {user && ['ADMIN', 'MIDADMIN'].includes(user.role) && (
                <>
                  <li className="dropdown-item">
                    <Link to="/branches" className="nav-links">지사관리</Link>
                  </li>
                </>
              )}
              {user && user.role === 'ADMIN' && (
                <>
                  <li className="dropdown-item">
                    <Link to="/users" className="nav-links">사용자 관리</Link>
                  </li>
                </>
              )}
            </ul>
          )}
        </li>
        {user && (
          <>
            <li className="nav-item user-info">
              <div className="notification-icon-container">
                <i className="fas fa-calendar-alt notification-icon" onClick={toggleNotificationModal}></i>
                {hasTodayTodo && <span className="notification-badge" onClick={toggleNotificationModal}>!</span>}
              </div>
              <span>{user.name}{'\u00A0'}{user.position === '직원' ? '사원' : user.position}님</span>
              <button onClick={logout} className="logout-button">로그아웃</button>
            </li>
          </>
        )}
      </ul>
      <NotificationModal
        isOpen={isNotificationModalOpen}
        onRequestClose={toggleNotificationModal}
      />
    </nav>
  );
}

export default NavigationBar;